import { ApiUrl, ApiUrlAdmin } from "../common/Config";
import { postAdmin,post,get,getAdmin,postFormData } from "../common/Helper";

export const getCourseInteractionVideos = async (token,segmentId) =>{
    let url = ApiUrl + `cms/getcourseinteractionvideos?segmentId=${segmentId}`
    return await get(url,token)
}

export const addAchVideoInteraction = async (token,data) =>{
    let url = ApiUrl + `book/addachievementvideointeraction`
    return await post(url,data,token)
}

export const getAchievementInteractionVideos = async (token,data) =>{
    let url = ApiUrl + `book/getachievementinteractionvideos`
    return await post(url,data,token)
}

export const openInteractionVideo = async (token,data) =>{
    let url = ApiUrl + `book/getachievementinteractionvideo`
    return await post(url,data,token)
}

export const updateInteractionVideo = async (token,data) =>{
    let url = ApiUrl + `book/updateachievementvideointeraction`
    return await post(url,data,token)
}
export const deleteInteractionVideo = async (token,data) =>{
    let url = ApiUrl + `book/deleteachievementvideointeraction`
    return await post(url,data,token)
}

